(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notifications', {
            parent: 'entity',
            url: '/notifications',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Notifications'
            },
            ncyBreadcrumb: {
                label: 'Notifications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notifications/notifications.html',
                    controller: 'NotificationsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('notifications-detail', {
            parent: 'entity',
            url: '/notifications/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Notifications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notifications/notifications-detail.html',
                    controller: 'NotificationsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Notifications', function($stateParams, Notifications) {
                    return Notifications.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'notifications',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('notifications-detail.edit', {
            parent: 'notifications-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notifications/notifications-dialog.html',
                    controller: 'NotificationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Notifications', function(Notifications) {
                            return Notifications.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notifications.new', {
            parent: 'notifications',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notifications/notifications-dialog.html',
                    controller: 'NotificationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                description: null,
                                priorityLevel: null,
                                viewed: false,
                                reviewedDate: null,
                                state: null,
                                stateParams: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function () {
                    $state.go('notifications', null, {reload: true});
                    CoreService.scrollToPosition('care-coordination', 80, 100);
                }, function () {
                    $state.go('notifications');
                });
            }]
        })
        .state('notifications.edit', {
            parent: 'notifications',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notifications/notifications-dialog.html',
                    controller: 'NotificationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Notifications', function(Notifications) {
                            return Notifications.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notifications', null, { reload: 'notifications' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notifications.delete', {
            parent: 'notifications',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notifications/notifications-delete-dialog.html',
                    controller: 'NotificationsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Notifications', function(Notifications) {
                            return Notifications.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notifications', null, { reload: 'notifications' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
